<template>
  <v-row no-gutter dense justify="center" align="center" class="tj-pager">
    <v-col
      cols="auto"
      align-self="stretch"
      class="d-flex align-stretch"
      style="min-height:40px;"
    >
      <v-btn
        title="Ir para a primeira página"
        class="mr-1 auto-height tj-pager-btn"
        :dense="true"
        :outlined="true"
        :small="true"
        @click="onMoveFirst"
      >
        <v-icon>mdi-chevron-double-left</v-icon>
      </v-btn>

      <v-btn
        title="Página anterior"
        class="mr-2 auto-height tj-pager-btn"
        :dense="true"
        :outlined="true"
        :disabled="!canMovePrev"
        :small="true"
        @click="onMovePrev"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <v-btn
        v-for="p in displayPages"
        :key="p"
        class="mr-1 auto-height tj-pager-btn"
        :dense="true"
        :small="true"
        :color="p === currentPage ? 'primary' : 'secondary'"
        @click="gotoPage(p)"
      >
        <b>{{ p }}</b>
      </v-btn>

      <v-btn
        title="Próxima Página"
        class="mx-1 auto-height tj-pager-btn"
        :dense="true"
        :outlined="true"
        :disabled="!canMoveNext"
        :small="true"
        @click="onMoveNext"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>

      <v-btn
        title="Ir para a última página"
        class="auto-height tj-pager-btn"
        :dense="true"
        :outlined="true"
        :small="true"
        @click="onMoveLast"
      >
        <v-icon>mdi-chevron-double-right</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Vue from "vue";

const DEFAULT_SIZES = [5, 10, 50, 100];
//const FEFAULT_SIZE = 10;
const DEFAULT_SLOTS = 7;

export default Vue.component("tj-pager", {
  model: {
    prop: "page",
    event: "page-changed"
  },
  props: {
    size: Number,
    total: Number,
    page: Number,
    sizeList: Array,
    slots: Number,
    syncPageUpdate: {
      type: Boolean,
      default: true
    },
    topSizeMenu: Boolean
  },

  data: function() {
    return {
      currentPage: this.asPage(this.page),
      itemCount: this.asCount(this.total),
      pageSizeList: this.asSizeList(this.sizeList),
      pageSize: this.asSize(this.size),
      slotCount: this.asSlots(this.slots)
    };
  },

  computed: {
    isCurrentPage: function() {
      var p = this.page;
      var p2 = this.currentPage;
      return function(v) {
        return v === p || v === p2;
      };
    },

    canMovePrev: function() {
      return this.currentPage > 1;
    },

    canMoveNext: function() {
      return this.currentPage < this.pageCount;
    },

    pageCount: function() {
      var v1 = this.itemCount;
      var v2 = this.pageSize;
      return Math.max(1, Math.ceil(v1 / v2));
    },

    displayPages: function() {
      if (this.slotCount === 1) return [this.currentPage];

      var result = [];
      var cur = this.currentPage;
      var count = this.pageCount;

      var mid = Math.max(this.slotCount >> 1, 1);
      var slots = (mid << 1) + 1;

      var first = Math.max(1, cur - mid);
      var last = Math.min(count, first + slots - 1);
      first = Math.max(1, last - slots + 1);

      for (var i = first; i <= last; ++i) result.push(i);
      return result;
    }
  },

  watch: {
    pageSize: function(v) {
      this.$emit("size-changed", v);
    },

    total: function(v) {
      this.itemCount = this.asCount(v);
    },

    page: function(v) {
      v = this.asPage(v);
      if (v !== this.currentPage) this.currentPage = v;
    },

    size: function(v) {
      v = this.asSize(v);
      if (v !== this.pageSize) this.pageSize = v;
    },

    sizeList: function(v) {
      this.pageSizeList = this.asSizeList(v);
    },

    slots: function(v) {
      v = this.asSlots(v);
      if (v !== this.slotCount) this.slotCount = v;
    }
  },

  methods: {
    asSizeList: function(v) {
      return Array.isArray(v) && v.length ? v : DEFAULT_SIZES;
    },

    asPage: function(v) {
      return Math.max(v || 0, 1);
    },

    asSize: function(v) {
      return v == null ? DEFAULT_SIZE : Math.max(v || 0, 1);
    },

    asCount: function(v) {
      return Math.max(v || 0, 0);
    },

    asSlots: function(v) {
      return v == null ? DEFAULT_SLOTS : Math.max(v || 0, 1);
    },

    onMoveFirst: function() {
      this.gotoPage(1);
    },

    onMovePrev: function() {
      this.gotoPage(this.currentPage - 1);
    },

    onMoveNext: function() {
      this.gotoPage(this.currentPage + 1);
    },

    onMoveLast: function() {
      this.gotoPage(this.pageCount);
    },

    gotoPage: function(v) {
      v = +v || 0;
      if (v > 0 && v <= this.pageCount && v !== this.page) {
        if (!this.syncPageUpdate) this.currentPage = v;
        this.$emit("page-changed", v);
      }
    }
  }
});
</script>

<style>
.tj-pager button.tj-pager-btn {
  height: 34px !important;
  min-width: 34px !important;
  padding: 0 4px !important;
}
</style>
